<template>
  <div class="zoox-pagination-wrapper">
    <!--Evento emitido ao mudar de página
        @event change:page
        @property {Number} currentPage Número da página atual
     -->
    <z-auto-pagination
      v-if="autoPagination"
      :items-per-page="itemsPerPage"
      :items="items"
      :icon-next="iconNext"
      :icon-previous="iconPrevious"
      :show-items-per-page="showItemsPerPage"
      :items-per-page-options="itemsPerPageOptions"
      :items-per-page-text="itemsPerPageText"
      @change:items-per-page="$emit('change:items-per-page', +$event)"
      @change:page="$emit('change:page', +$event)"
    >
      <template #data="{paginatedItems}">
        <!-- @slot Slot a ser usado para paginar os itens 
              @binding {Array} paginatedItems Array dos itens paginados
        -->
        <slot name="data" :paginatedItems="paginatedItems" />
      </template>

      <template #actions>
        <!-- @slot Slot a ser usado para adicionar ações na paginação -->
        <slot name="actions" />
      </template>
    </z-auto-pagination>

    <!--Evento emitido ao clicar no ícone de `next`
        @event click:next
     -->

    <!--Evento emitido ao clicar no ícone de `previous`
        @event click:previous
     -->

    <!--Evento emitido ao mudar de página
        @event change:page
        @property {Number} currentPage Número da página atual
     -->
    <z-visual-pagination
      v-else
      :number-of-pages="numberOfPages"
      :current-page="currentPage"
      :icon-next="iconNext"
      :icon-previous="iconPrevious"
      :items-per-page="itemsPerPage"
      :show-items-per-page="showItemsPerPage"
      :items-per-page-options="itemsPerPageOptions"
      :items-per-page-text="itemsPerPageText"
      @change:items-per-page="$emit('change:items-per-page', $event)"
      @click:next="$emit('click:next')"
      @click:previous="$emit('click:previous')"
      @change:page="$emit('change:page', $event)"
    >
      <template #data>
        <!-- @slot Slot a ser usado para paginar os itens 
              @binding {Array} paginatedItems Array dos itens paginados
        -->
        <slot name="data" :paginatedItems="items" />
      </template>

      <template #actions>
        <!-- @slot Slot a ser usado para adicionar ações na paginação -->
        <slot name="actions" />
      </template>
      <template #precontrols>
        <slot name="precontrols"></slot>
      </template>
    </z-visual-pagination>
  </div>
</template>

<script>
/**
 * @displayName Paginação
 */
export default {
  name: 'ZPagination',
  props: {
    /**
     * Flag para indicar ao componente fazer a paginação automática
     */
    autoPagination: {
      type: Boolean,
      required: true,
    },
    /**
     * Determina a quantidade de itens a serem mostrados na paginação
     */
    itemsPerPage: {
      type: Number,
      default: 5,
    },
    /**
     * Determina as opções de quantidade de itens por página
     */
    itemsPerPageOptions: {
      type: Array,
      default: () => [5, 10, 15, 20, 25, 50, 100],
    },
    /**
     * Flag para indicar ao componente mostrar a opção de quantidade de itens por página
     */
    showItemsPerPage: {
      type: Boolean,
      default: false,
    },
    /**
     * Texto a ser mostrado na opção de quantidade de itens por página
     */
    itemsPerPageText: {
      type: String,
      default: '',
    },
    /**
     * Número total de itens a serem paginados
     */
    numberOfItems: {
      type: Number,
      required: false,
    },
    /**
     * Determina o numero de páginas da paginação (ignorada com a prop 'auto-pagination')
     */
    numberOfPages: {
      type: Number,
    },
    /**
     * Indica qual a página atual da paginação (ignorada com a prop 'auto-pagination')
     */
    currentPage: {
      type: Number,
    },
    /**
     * Determina qual são os itens a serem paginados (apenas ao usar a prop 'auto-pagination' )
     */
    items: {
      type: Array,
    },
    /**
     * Flag para indicar ao componente o ícone que irá passar as páginas para direita.
     */
    iconNext: {
      type: String,
      default: '$keyboard_arrow_right_rounded',
    },
    /**
     * Flag para indicar ao componente o ícone que irá passar as páginas para esquerda.
     */
    iconPrevious: {
      type: String,
      default: '$keyboard_arrow_left_rounded',
    },
  },
}
</script>

<style scoped>
.zoox-pagination-wrapper {
  position: relative;
  height: 100%;
  padding-bottom: 40px;
}
</style>
